import { TransactionProps } from '../transactions';
import { useGoalAccount } from './helpers';

// I originally had this in common/src/react/transactions, but it caused a circular dependency
export const useIsGoalToGoalTransaction = (
    transaction: TransactionProps | null | undefined
): boolean | null => {
    const sourceGoalAccount = useGoalAccount(transaction?.sourceId ?? '');
    const destinationGoalAccount = useGoalAccount(
        transaction?.destinationId ?? ''
    );

    if (!transaction?.sourceId || !transaction?.destinationId) return null;

    return !!(sourceGoalAccount && destinationGoalAccount);
};
